export default __webpack_public_path__ + "static/media/REVV.f2805e7d.svg";